import React, { useRef, useEffect, useState } from 'react';

interface OverflowBounceTextProps {
  text: string;
  className?: string;
}

const OverflowBounceText: React.FC<OverflowBounceTextProps> = ({ text, className = '' }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && textRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const textWidth = textRef.current.scrollWidth;
        setIsOverflowing(textWidth > containerWidth);
        setContainerWidth(containerWidth);
      }
    };

    checkOverflow();
    
    // Re-check on window resize
    window.addEventListener('resize', checkOverflow);
    
    // Check after fonts load
    const timeout = setTimeout(checkOverflow, 100);
    
    return () => {
      window.removeEventListener('resize', checkOverflow);
      clearTimeout(timeout);
    };
  }, [text]);

  return (
    <div 
      ref={containerRef} 
      className={`overflow-bounce-container ${className}`}
      style={isOverflowing ? { '--container-width': `${containerWidth}px` } as React.CSSProperties : undefined}
    >
      <span 
        ref={textRef}
        className={isOverflowing ? 'animate-bounce-text' : ''}
      >
        {text}
      </span>
    </div>
  );
};

export default OverflowBounceText;